import { render, staticRenderFns } from "./detailCartonDisplayInformation.vue?vue&type=template&id=1670c999&"
import script from "./detailCartonDisplayInformation.vue?vue&type=script&lang=js&"
export * from "./detailCartonDisplayInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports